import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { MarkdownSectionDTO } from '@lib/strapi/dtos/components/sections/markdownSection.dto';
import { Prose } from '../shared-ui';

const MarkdownSectionImplementation = ({ section }: ComponentProps<MarkdownSectionDTO>) => {
  if (!section?.content) return null;
  return (
    // <article>: the sidebar TOC indexes `article h2`, so long markdown
    // bodies (the legal pages) get the same «Σε αυτή τη σελίδα» chapters as
    // treatments and conditions (owner, 2026-09-08)
    <section className="py-4">
      <article>
        <Prose content={section.content} />
      </article>
    </section>
  );
};

export default MarkdownSectionImplementation;
